import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const saveRoiSurveyMutation = async (answersData) =>
  await DataQuery(`
    mutation {
      save_users_roi_answers(${jsonToInputParams({
        answers: JSON.stringify(answersData),
      })}) {
        success
        errors
      }
    }`);

const saveRoiSurveyMutationParseQuery = (data) => ({
  errors: resolve(data, 'save_users_roi_answers/errors', []),
  success: resolve(data, 'save_users_roi_answers/success', false),
});

const saveRoiSurvey = async (answers) => {
  let success;
  let errors;
  try {
    const { data } = await saveRoiSurveyMutation(answers);
    const {
      success: mutationSuccess,
      errors: mutationErrors,
    } = saveRoiSurveyMutationParseQuery(data);
    success = mutationSuccess;
    errors = mutationErrors;
    if (!success) {
      console.error(mutationErrors);
    }
  } catch (e) {
    console.error(e);
  }
  return {
    success: success,
    errors: errors,
  };
};

export { saveRoiSurvey };
